// Where a section's button goes (hero, call to action). Pure, so
// tests/buttonTarget.test.js runs it under plain node.
//
// A section stores {scrollTarget, navigateTo}: scrollTarget (a section id)
// wins when both are set, as it always has. navigateTo is a page path
// ('/contact'), a web address, or a phone or email link ('tel:', 'mailto:')
// so "Call us" works.

const filled = (v) => typeof v === "string" && v.trim() !== "";

// -> {kind: 'scroll', id} | {kind: 'external', href} | {kind: 'route', path} | null
export function linkTarget(navigateTo) {
    if (!filled(navigateTo)) return null;
    const v = navigateTo.trim();
    if (/^tel:/i.test(v)) {
        // Phones read digits and a leading +; spaces, dots and brackets go.
        const number = v.slice(4).replace(/[^\d+#*,;]/g, "");
        return /\d/.test(number) ? {kind: "external", href: `tel:${number}`} : null;
    }
    if (/^mailto:/i.test(v)) {
        const address = v.slice(7);
        return /^[^\s@]+@[^\s@]+$/.test(address.split("?")[0]) ? {kind: "external", href: `mailto:${address}`} : null;
    }
    if (/^https?:\/\/[^\s]+$/i.test(v)) return {kind: "external", href: v};
    // Any other scheme (javascript:, data:...) goes nowhere.
    if (/^[a-z][a-z0-9+.-]*:/i.test(v)) return null;
    if (v.startsWith("#")) return v.length > 1 ? {kind: "scroll", id: v.slice(1)} : null;
    return {kind: "route", path: v.startsWith("/") ? v : `/${v}`};
}

export function buttonAction({scrollTarget, navigateTo} = {}) {
    if (filled(scrollTarget)) return {kind: "scroll", id: scrollTarget.trim()};
    return linkTarget(navigateTo);
}

// The hero's scroll target: the section's own, else none when it navigates
// somewhere, else the next section (the old default, kept for heroes with no
// destination set).
export function heroScrollTarget(section, nextId) {
    if (!section || typeof section !== "object") return "";
    if (filled(section.scrollTarget)) return section.scrollTarget.trim();
    if (linkTarget(section.navigateTo)) return "";
    return typeof nextId === "string" ? nextId : "";
}
